import qs from "query-string";
import { BEConfig } from "../config/env";
import { webapiGet } from "../webapis/core";
import ApiService from "./apiService";

class DeliveryInfoService extends ApiService {
  async getDeliveryInfo(tier: string) {
    const { settingsHandle, deliveryInfo } = BEConfig.commonApi;

    const endpoint = qs.stringifyUrl(
      {
        url: `${this.getBaseUrl()}${settingsHandle}${deliveryInfo}`,
        query: {
          tier
        }
      },
      { encode: false }
    );

    const response = await webapiGet(
      this.getAccessToken(),
      endpoint,
      this.getVisitorId()
    ).request;

    return response.data;
  }

  getBaseUrl(): string {
    const { protocol, baseURL, port, versionInfo } = BEConfig.commonApi;

    return `${protocol}${baseURL}${port}${versionInfo}`;
  }
}

const deliveryInfoService = new DeliveryInfoService();

export default deliveryInfoService;
